import { LOCK_ACTIONS, UNLOCK_ACTIONS, SHOW_OTP_MODAL, HIDE_OTP_MODAL } from "./actionTypes";
import { LOGOUT_USER, LOGOUT_USER_SUCCESS } from "../auth/login/actionTypes";

const savedTime = localStorage.getItem("otpUnlockedUntil");
const isValid = savedTime && parseInt(savedTime) > Date.now();

const initialState = {
  isUnlocked: isValid,
  unlockedUntil: isValid ? parseInt(savedTime) : null,
  isModalOpen: false,
};

const otpUnlockReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGOUT_USER:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        isUnlocked: false,
        unlockedUntil: null,
        isModalOpen: false,
      };
    case UNLOCK_ACTIONS:
      return {
        ...state,
        isUnlocked: true,
        unlockedUntil: action.payload,
      };
    case LOCK_ACTIONS:
      return {
        ...state,
        isUnlocked: false,
        unlockedUntil: null,
      };
    case SHOW_OTP_MODAL:
      return {
        ...state,
        isModalOpen: true,
      };
    case HIDE_OTP_MODAL:
      return {
        ...state,
        isModalOpen: false,
      };
    default:
      return state;
  }
};

export default otpUnlockReducer;
